import Skeleton from "../../../../../shared/components/UI/Skeleton/Skeleton";

const CreateEventFormSkeleton = () => {
    return (
        <div className="manageEventModal__createForm">
            <div style={{ marginBottom: "20px" }}>
                <Skeleton width="250px" height="28px" borderRadius="4px" />
            </div>

            {Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="manageEventModal__createForm-fieldWrapper">
                    <Skeleton width="100%" height="64px" borderRadius="8px" />
                </div>
            ))}

            <div className="manageEventModal__createForm-fieldWrapper">
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <Skeleton width="20px" height="20px" borderRadius="4px" />
                    <Skeleton width="200px" height="16px" borderRadius="4px" />
                </div>
                <div>
                    <Skeleton width="300px" height="14px" borderRadius="4px" />
                </div>
            </div>

            {/* IMAGES - FIX RESPONSIVE */}
            <div className="images">
                <div style={{ marginBottom: "10px" }}>
                    <Skeleton width="150px" height="14px" borderRadius="4px" />
                </div>

                <div
                    className="images__icons"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "12px",
                        maxWidth: "100%",
                    }}
                >
                    <div className="images__image-wrapper">
                        <Skeleton
                            width="100%"
                            height="100%"
                            borderRadius="8px"
                        />
                    </div>
                </div>

                <div>
                    <Skeleton width="100%" height="14px" borderRadius="4px" />
                </div>
            </div>

            {/* KMZ - FIX RESPONSIVE */}
            <div className="kmz-upload">
                <div style={{ marginBottom: "10px" }}>
                    <Skeleton width="150px" height="14px" borderRadius="4px" />
                </div>

                <div
                    className="kmz-upload__wrapper"
                    style={{
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    <Skeleton width="100%" height="100px" borderRadius="8px" />
                </div>

                <div style={{ marginTop: "10px" }}>
                    <Skeleton width="100%" height="14px" borderRadius="4px" />
                </div>
            </div>

            <div>
                <Skeleton width="100%" height="62px" borderRadius="8px" />
            </div>

            <div>
                <Skeleton width="100%" height="62px" borderRadius="8px" />
                <div style={{ marginTop: "10px" }}>
                    <Skeleton width="100%" height="14px" borderRadius="4px" />
                </div>
            </div>

            <div>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <Skeleton width="20px" height="20px" borderRadius="4px" />
                    <Skeleton width="200px" height="16px" borderRadius="4px" />
                </div>
                <div style={{ marginTop: "8px" }}>
                    <Skeleton width="100%" height="14px" borderRadius="4px" />
                </div>
            </div>

            <div>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <Skeleton width="20px" height="20px" borderRadius="4px" />
                    <Skeleton width="150px" height="16px" borderRadius="4px" />
                </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Skeleton width="206px" height="48px" borderRadius="10px" />
            </div>

            <style>{`
                .images__image-wrapper {
                    width: 100px;
                    height: 100px;
                    max-width: 100%;
                }

                @media (max-width: 768px) {
                    .images__image-wrapper {
                        width: 72px;
                        height: 72px;
                    }
                }
            `}</style>
        </div>
    );
};

export default CreateEventFormSkeleton;